import { createReducer, on } from "@ngrx/store";
import { TreatmentPlanApiActions } from "../actions/action-index";
import { TreatmentConfiguration } from "./treatment-configuration";

export const featureKey = "configuration";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface State extends TreatmentConfiguration {}

export const initialState: State = {
  isAcceledentOffered: false,
  isContractEditable: false,
};

export const reducer = createReducer(
  initialState,
  on(
    TreatmentPlanApiActions.loadConfigurationSuccess,
    (state, { configuration }) => ({
      ...state,
      isAcceledentOffered: configuration.IsAcceledentOffered,
      isContractEditable: configuration.IsContractEditable,
    })
  )
);
